const SETTINGS_SCHEDULING_KEY = 'scheduling';
const SETTINGS_SCHEDULING_VALUE = 'schedule';

const SETTINGS_PROPERTY_DETAILS_KEY = 'displayPropertyDetails';
const SETTINGS_PROPERTY_DETAILS_VALUE = true;

const SETTINGS_SERVICES_KEY = 'displayServices';
const SETTINGS_SERVICES_VALUE = true;

const SETTINGS_SERVICE_PRICES_KEY = 'displayServicePrices';
const SETTINGS_SERVICE_PRICES_VALUE = true;

const SETTINGS_BLOCK_APPOINTMENTS_KEY = 'blockAppointments';
const SETTINGS_BLOCK_APPOINTMENTS_VALUE = true;

const getCompanySettingByKey = (settings, settingKey) => {
  if (!settings) {
    return null;
  }
  return settings.find(setting => setting.type === settingKey);
};

const blockAppointmentsEnabled = state => {
  const foundSetting = getCompanySettingByKey(state.settings, SETTINGS_BLOCK_APPOINTMENTS_KEY);
  return foundSetting
    ? foundSetting.value === SETTINGS_BLOCK_APPOINTMENTS_VALUE
    : false;
};

const getCompany = state => state.company || {};

const companyLegacyId = state => (state.company
  ? state.company.id
  : null);

const companyUuid = state => (state.company
  ? state.company.companyId
  : null);

const schedulingIsEnabled = state => {
  const foundSetting = getCompanySettingByKey(state.settings, SETTINGS_SCHEDULING_KEY);
  return foundSetting
    ? (state.isActive && foundSetting.value === SETTINGS_SCHEDULING_VALUE)
    : false;
};

const servicesIsEnabled = state => {
  const foundSetting = getCompanySettingByKey(state.settings, SETTINGS_SERVICES_KEY);
  return foundSetting
    ? foundSetting.value === SETTINGS_SERVICES_VALUE
    : false;
};

const servicePricesIsEnabled = state => {
  const foundSetting = getCompanySettingByKey(state.settings, SETTINGS_SERVICE_PRICES_KEY);
  return foundSetting
    ? foundSetting.value === SETTINGS_SERVICE_PRICES_VALUE
    : false;
};

const propertyDetailsIsEnabled = state => {
  const foundSetting = getCompanySettingByKey(state.settings, SETTINGS_PROPERTY_DETAILS_KEY);
  return foundSetting
    ? foundSetting.value === SETTINGS_PROPERTY_DETAILS_VALUE
    : false;
};

export default {
  blockAppointmentsEnabled,
  companyLegacyId,
  companyUuid,
  getCompany,
  propertyDetailsIsEnabled,
  schedulingIsEnabled,
  servicesIsEnabled,
  servicePricesIsEnabled,
};
